import Rails from "@rails/ujs";
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['entries', 'pagination']

  connect() {
    //console.log("hello infinite_scroll")
    this.loadingMore = false
  }

  scroll(event) {
    if (this.loadingMore) return

    let next_page = this.paginationTarget.querySelector("a[aria-label='Next']")
    if (next_page == null) return

    let url = next_page.href

    let scrollPosition, scrollHeight

    // Check if we're listening to window scroll or element scroll
    if (event.target === document || event.target === window) {
      // Window scroll
      scrollPosition = window.scrollY + window.innerHeight
      scrollHeight = document.documentElement.scrollHeight
    } else {
      // Element scroll (table with overflow)
      const container = this.element
      scrollPosition = container.scrollTop + container.clientHeight
      scrollHeight = container.scrollHeight
    }

    // If we're within 100px of the bottom, load more
    if (scrollPosition >= scrollHeight - 100) {
      this.loadMore(url)
    }
  }


  loadMore(url) {
    Rails.ajax({
      type: 'GET',
      url: url,
      dataType: 'json',
      beforeSend: () => {
        this.loadingMore = true
        return true
      },
      success: (data) => {
        this.entriesTarget.insertAdjacentHTML('beforeend', data.entries)
        this.paginationTarget.innerHTML = data.pagination
        this.currentPage = data.current_page
        this.loadingMore = false
        //console.log(this.currentPage)
      }
    })
  }

}